// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-button svg path, .submit-button svg path {\n    fill: rgb(var(--color-light-text)) !important;\n}", ""]);
// Exports
module.exports = exports;
